export const IBREPORTS_SUMMARY_FETCH = 'IBREPORTS_SUMMARY_FETCH'
export const IBREPORTS_CONTRACT_DETAILS_FETCH = 'IBREPORTS_CONTRACT_DETAILS_FETCH'
export const IBREPORTS_REBATE_EARNINGS_FETCH = 'IBREPORTS_REBATE_EARNINGS_FETCH'
export const IBREPORTS_TRADING_ACCOUNTS_FETCH = 'IBREPORTS_TRADING_ACCOUNTS_FETCH'
export const IBREPORTS_ACCOUNT_STATEMENT_FETCH = 'IBREPORTS_ACCOUNT_STATEMENT_FETCH'
export const IBREPORTS_IS_FETCHING = 'IBREPORTS_IS_FETCHING'
export const IBREPORTS_API = 'ibreports'


// WEBPACK FOOTER //
// ./src/constants/ibReports.js